/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1EnvironmentEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_ENVIRONMENT_EVENT_ENTITY_NAME = 'o5.aws.deployer.v1.EnvironmentEvent';
export const o5AwsDeployerV1EnvironmentEventEntity = new schema.Entity<O5AwsDeployerV1EnvironmentEvent>(O5_AWS_DEPLOYER_V1_ENVIRONMENT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: O5AwsDeployerV1EnvironmentEvent) => `${entity.metadata?.eventId}` });

